import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  useLazyGetMessagesQuery,
} from '../chatApi';

import { useGetAppConfigQuery } from 'app/api/mainApi';
import Messages from './Messages';

import {
  appendMessagesForContact,
  currentContactSelector,
  recentMaxIdForContactSelector,
  messagesForContactSelector,
  uiStateForContactSelector,
  allMessagesLoadedForContactSelector,
} from '../nfChatSlice';

const MessagesContainer = () => {
  const dispatch = useDispatch();
  const currentContact = useSelector(currentContactSelector);

  const recentMaxId = useSelector((state) => {
    return recentMaxIdForContactSelector(state, currentContact?.id);
  });

  const allMessages = useSelector((state) => {
    return messagesForContactSelector(state, currentContact?.id);
  });

  const uiState = useSelector((state) => {
    return uiStateForContactSelector(state, currentContact?.id);
  });

  const allMessagesLoaded = useSelector((state) => {
    return allMessagesLoadedForContactSelector(state, currentContact?.id);
  });

  const PER_PAGE = 10;

  const [triggerGetMessages, {
    data: messagesPage,
    isSuccess: messagesSuccess,
  }] = useLazyGetMessagesQuery();

  const currentUser = useGetAppConfigQuery().data?.current_user;

  const maybeFetchMoreMessages = () => {
    if (allMessagesLoaded) return;

    triggerGetMessages({
      selectedUserId: currentContact?.other_user.id,
      maxId: recentMaxId, // the lowest id from the last page of messages fetched
      perPage: PER_PAGE,
    });
  };

  useEffect(() => {
    if (currentContact && uiState.initialRender) {
      triggerGetMessages({
        selectedUserId: currentContact.other_user.id,
        maxId: recentMaxId,
        perPage: PER_PAGE,
      });
    }
  }, [currentContact]);

  useEffect(() => {
    if (messagesSuccess) {
      dispatch(appendMessagesForContact({
        contactId: currentContact.id,
        newMessages: messagesPage,
      }));
    }
  }, [messagesPage]);

  if (!currentContact || !allMessages) return null;

  return (
    <Messages
      messages={allMessages}
      currentUser={currentUser}
      currentContact={currentContact}
      onScrolledToTop={maybeFetchMoreMessages}
      perPage={PER_PAGE}
    />
  );
};

export default MessagesContainer;
